<template>
    <div class="col-12">
        <div class="d-flex row" v-if="this.user.recentJourneys">
            <RecentJouneyItem
                v-for="(journey, index) in recent"
                :key="index"
                :payload="journey"
                id="journey-item"
                >
            </RecentJouneyItem>
            <div class="col-12 d-flex justify-content-center mt-4">
                <b-pagination
                    aria-controls="journey-item"
                    :total-rows="total"
                    v-model="page"
                    :per-page="perPage"
                    prev-text="Prev"
                    next-text="Next"
                    @change="handlePageChange"
                    ></b-pagination>
            </div>
        </div>
        <div v-else class="d-flex row">
            <h3>
                There are no recent searches
            </h3>
        </div>
    </div>
</template>

<script>
import {
    mapState,
    mapActions,
} from 'vuex'
import RecentJouneyItem from './RecentJourneyItem.vue'

export default {
    name: 'Account',
    components: {
        RecentJouneyItem,
    },
    data() {
        return {
            page: 1,
            perPage: 10,
        }
    },
    computed: {
        ...mapState([
            'user',
        ]),
        recent() {
            const journey = this.user.recentJourneys
            return journey;
        },
        total() {
            return this.user.recentJourneysMeta.total
        },
    },
    methods: {
        ...mapActions([
            'getRecentJourneysForUser',
        ]),
        getRecentItems() {
            this.getRecentJourneysForUser({
                params: {
                    per_page: this.perPage,
                    page: this.page,
                },
            })
        },
        handlePageChange(value) {
            this.page = value;
            this.getRecentItems(value)
        },
    },
    created() {
        this.getRecentItems()
    },

}
</script>
